var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "file-upload" }, [
    _c(
      "label",
      { staticClass: "upload-area" },
      [
        _c("input", {
          staticClass: "file-input",
          attrs: { type: "file", accept: "image/*" },
          on: { change: _vm.handleFileChange },
        }),
        _vm.previewUrl && _vm.isUploaded
          ? [
              _c("img", {
                staticClass: "preview-image",
                attrs: { src: _vm.previewUrl, alt: "预览图" },
              }),
            ]
          : [
              _c("span", [
                _c("i", { staticClass: "upload-icon" }),
                _vm._v(_vm._s(_vm.placeholder)),
              ]),
            ],
      ],
      2
    ),
    _vm.uploadProgress > 0 && _vm.uploadProgress < 100
      ? _c("div", { staticClass: "progress-container" }, [
          _c("div", {
            staticClass: "progress-bar",
            style: { width: _vm.uploadProgress + "%" },
          }),
          _c("span", { staticClass: "progress-text" }),
        ])
      : _vm._e(),
    _vm.error
      ? _c("div", { staticClass: "error-message" }, [_vm._v(_vm._s(_vm.error))])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }